import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/service/computational_equipment_thumbnail.png'
import _imports_1 from '@/assets/product/correct.svg'
import _imports_2 from '@/assets/service/domestic_data_centers_thumbnail.png'
import _imports_3 from '@/assets/service/international_data_centers_thumbnail.png'


const _withScopeId = n => (_pushScopeId("data-v-4d7d2e72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assets" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "computational equipment",
  class: "thunbnail"
}, null, -1))
const _hoisted_3 = { class: "introduce" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "options" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "domestic data centers",
  class: "thunbnail"
}, null, -1))
const _hoisted_8 = { class: "introduce" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "options" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "international data centers",
  class: "thunbnail"
}, null, -1))
const _hoisted_13 = { class: "introduce" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "options" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

import provide_key from "@/constant/provide_key";
import { inject, onMounted, ref, watch, nextTick } from "vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'LiquidCooling',
  emits: ["height"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const { locale } = useI18n();
const contentRef = ref<null | HTMLElement>(null);

const shrink: boolean | undefined = inject(provide_key.SHRINK);

onMounted(() => {
  watch(
    () => locale.value,
    () => {
      if (contentRef.value) {
        nextTick(() => emits("height", contentRef.value?.offsetHeight))
      }
    },
    { immediate: true }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "liquid_cooling",
    ref_key: "contentRef",
    ref: contentRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "asset",
        style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row-reverse' })
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("service.COMPUTATIONAL_EQUIPMENT")), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
              return _createElementVNode("div", {
                class: "option",
                key: index
              }, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`service.COMPUTATIONAL_EQUIPMENT_DESCRIPTION_${index}`)), 1)
              ])
            }), 64))
          ])
        ])
      ], 4),
      _createElementVNode("div", {
        class: "asset",
        style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row' })
      }, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("service.DOMESTIC_DATA_CENTERS")), 1),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item, index) => {
              return _createElementVNode("div", {
                class: "option",
                key: index
              }, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`service.DOMESTIC_DATA_CENTERS_DESCRIPTION_${index}`)), 1)
              ])
            }), 64))
          ])
        ])
      ], 4),
      _createElementVNode("div", {
        class: "asset",
        style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row-reverse' })
      }, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("service.INTERNATIONAL_DATA_CENTERS")), 1),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item, index) => {
              return _createElementVNode("div", {
                class: "option",
                key: index
              }, [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`service.INTERNATIONAL_DATA_CENTERS_DESCRIPTION_${index}`)), 1)
              ])
            }), 64))
          ])
        ])
      ], 4)
    ])
  ], 512))
}
}

})